class SafeLoadScripts extends HTMLElement {
  constructor() {
    super();
  }

  scheduleIdle(callback) {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(callback, { timeout: 2500 });
    } else {
      window.addEventListener(
        'load',
        () => {
          window.setTimeout(callback, 0);
        },
        { once: true },
      );
    }
  }

  scheduleInteraction(callback, script) {
    const triggerSelector = script.dataset.loadTrigger;
    const triggers = triggerSelector
      ? Array.from(document.querySelectorAll(triggerSelector))
      : [this.parentElement].filter(Boolean);

    if (triggers.length === 0) {
      this.scheduleIdle(callback);
      return;
    }

    const events = ['pointerover', 'focusin', 'pointerdown'];
    const listenerOptions = { passive: true, capture: false };
    const detachers = [];
    let fired = false;

    const handler = () => {
      if (fired) {
        return;
      }
      fired = true;
      detachers.forEach((detach) => detach());
      callback();
    };

    triggers.forEach((target) => {
      events.forEach((event) => {
        target.addEventListener(event, handler, listenerOptions);
        detachers.push(() => target.removeEventListener(event, handler, listenerOptions));
      });
    });
  }

  loadScript(script) {
    const key = script.dataset.flowLoadKey;

    const scriptLoaded = window.wetheme.webcomponentRegistry.checkScriptLoaded(key);
    if (scriptLoaded) {
      return;
    }

    if (key) {
      window.wetheme.webcomponentRegistry.register({ key });
    }

    const postLoadedScript = document.createElement('script');
    const { src, defer, async, type } = script;
    postLoadedScript.src = src;
    postLoadedScript.defer = defer;
    postLoadedScript.async = async;
    postLoadedScript.type = type;

    this.parentElement.appendChild(postLoadedScript);
  }

  connectedCallback() {
    window.setTimeout(() => {
      if (!this.isConnected) {
        return;
      }

      const scripts = this.querySelectorAll(':scope > script');

      scripts.forEach((script) => {
        const runLoad = () => this.loadScript(script);
        const mode = script.dataset.scheduleLoad;
        if (mode === 'idle') {
          this.scheduleIdle(runLoad);
        } else if (mode === 'interaction') {
          this.scheduleInteraction(runLoad, script);
        } else {
          runLoad();
        }
      });
    }, 0);
  }
}

customElements.define('safe-load-scripts', SafeLoadScripts);